import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar"; // desktop menu
         import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn } from "react-icons/fa";

const Header = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  // ✅ prevent background scroll when drawer is open
  useEffect(() => {
    document.body.style.overflow = isDrawerOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isDrawerOpen]);

  return (
    <header className="main_header_area w-100 site-header">
      {/* Top bar */}
<div className="header-content text-black d-none d-lg-block bg-light border-bottom">
  <div className="container">
    <div className="header-content-inner py-2">
      <div className="row align-items-center">
        <div className="col-lg-6">

<ul className="m-0 p-0 d-flex gap-3 list-unstyled">
  {/* Facebook */}
  <li>
    <a
      href="https://www.facebook.com/share/16jvYa6rF7/?mibextid=wwXIfr"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "black", fontSize: "19px" }}
      onMouseEnter={(e) => (e.currentTarget.style.color = "#0a3d91")}
      onMouseLeave={(e) => (e.currentTarget.style.color = "black")}
    >
      <FaFacebookF />
    </a>
  </li>

  {/* Instagram */}
  <li>
    <a
      href="https://www.instagram.com/aro_events_?igsh=c2N5Z2diazZxN29y&utm_source=qr"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "black", fontSize: "19px" }}
      onMouseEnter={(e) => (e.currentTarget.style.color = "#0a3d91")}
      onMouseLeave={(e) => (e.currentTarget.style.color = "black")}
    >
      <FaInstagram />
    </a>
  </li>

  {/* X (Twitter) */}
  <li>
    <a
      href="https://x.com/AroEvents"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "black", fontSize: "19px" }}
      onMouseEnter={(e) => (e.currentTarget.style.color = "#0a3d91")}
      onMouseLeave={(e) => (e.currentTarget.style.color = "black")}
    >
      <FaTwitter />
    </a>
  </li>

  {/* LinkedIn */}
  <li>
    <a
      href="https://www.linkedin.com/company/aro-events/"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "black", fontSize: "19px" }}
      onMouseEnter={(e) => (e.currentTarget.style.color = "#0a3d91")}
      onMouseLeave={(e) => (e.currentTarget.style.color = "black")}
    >
      <FaLinkedinIn />
    </a>
  </li>
</ul>

        </div>

        {/* Right side contact info */}
        <div className="col-lg-6 text-end">
          <ul className="m-0 p-0 list-unstyled small">
          
          <li className="d-inline px-2">
  <a
    href="mailto:info@aroevents.com"
    style={{ color: "inherit", textDecoration: "none" }}
  >
    <i className="fa fa-envelope me-1"></i> info@aroevents.com
  </a>
</li>

          
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>



      {/* Navigation Bar */}
      <div className="header_menu bg-white shadow-sm" id="header_menu">
        <div className="container">
          <nav className="navbar navbar-expand-lg py-2">
            <div className="container-fluid">
              {/* Logo + text */}
              <Link to="/" className="navbar-brand m-0 d-flex align-items-center">
                <img src="assets/images/logo/3.png" alt="Logo" className="logo-img" />
                <div className="ms-2 logo-text">
                  {/* Long version (default) */}
                  <h6 className="fw-bold m-0 site-title long-title">
                    Future Oil Conference 2026
                  </h6>
                  <span className="text-muted site-tagline long-tagline">
                    AI, Data & the Net-Zero Energy Shift
                  </span>

                  {/* Short version (mobile only) */}
                  <h6 className="fw-bold m-0 site-title short-title">
                    Future Oil
                  </h6>
                  <span className="text-muted site-tagline short-tagline">
                    AI & Net-Zero
                  </span>
                </div>
              </Link>

              {/* Mobile toggle */}
              <button
                className="btn border-0 d-lg-none"
                onClick={() => setIsDrawerOpen(true)}
              >
                <i className="fa fa-bars fs-3"></i>
              </button>

              {/* Desktop Menu */}
              <div className="d-none d-lg-flex ms-auto align-items-center">
                <div className="me-lg-4">
                  <Navbar />
                </div>
                <Link to="/booknow" className="btn btn3">
                  Register Now <i className="fa fa-long-arrow-right ms-2"></i>
                </Link>
              </div>
            </div>
          </nav>
        </div>
      </div>

      {/* Right Drawer (Mobile Menu Only) */}
      <div
        className="position-fixed top-0 h-100 bg-white shadow p-4"
        style={{
          width: "300px",
          right: isDrawerOpen ? "0" : "-300px",
          transition: "right 0.3s ease-in-out",
          zIndex: 1050,
          overflowY: "auto",
        }}
      >
        <button
          className="btn-close position-absolute top-0 end-0 m-3"
          onClick={() => setIsDrawerOpen(false)}
        ></button>

        <div className="mt-5">
          <div className="border-bottom pb-3 mb-3">
            <ul className="m-0 p-0 list-unstyled small">
              <li className="mb-2"><i className="fa fa-envelope-o me-1"></i> info@aroevents.com</li>
         
            </ul>
          </div>

          {/* Mobile nav */}
          <ul className="list-unstyled drawer-navbar">
            <li><Link to="/" className="nav-link">Home</Link></li>
            <li><Link to="/agenda" className="nav-link">AGENDA</Link></li>

            <li>
              <button
                className="nav-link w-100 text-start"
                onClick={() => toggleDropdown("speaker")}
              >
                Speaker <i className={`fa fa-chevron-${openDropdown === "speaker" ? "up" : "down"} float-end`}></i>
              </button>
              {openDropdown === "speaker" && (
                <ul className="submenu list-unstyled">
                  <li><Link to="/becomespeaker" className="dropdown-item">Become a Speaker</Link></li>
                  <li><Link to="/speakerbenefits" className="dropdown-item">Benefits of Speaker</Link></li>
                </ul>
              )}
            </li>

            <li>
              <button
                className="nav-link w-100 text-start"
                onClick={() => toggleDropdown("schedule")}
              >
                Sponsor & Exhibit <i className={`fa fa-chevron-${openDropdown === "schedule" ? "up" : "down"} float-end`}></i>
              </button>
              {openDropdown === "schedule" && (
                <ul className="submenu list-unstyled">
                  <li><Link to="/sponsors" className="dropdown-item">Sponsorship & Benefits</Link></li>
                </ul>
              )}
            </li>

            <li><Link to="/contact" className="nav-link">Contact</Link></li>
            <li><Link to="/booknow" className="btn btn-primary w-100 mt-3">Register Now</Link></li>
          </ul>
        </div>
      </div>

      {/* Overlay */}
      {isDrawerOpen && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
          style={{ zIndex: 1040 }}
          onClick={() => setIsDrawerOpen(false)}
        ></div>
      )}

      {/* CSS */}
      <style>{`
/* ========================
   Logo + Text Styling
======================== */
.logo-img {
  height: 45px;
  width: 45px;
  object-fit: contain;
}

.logo-text {
  margin-left: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.1;
}

.site-title {
  font-size: clamp(0.85rem, 1vw, 1.05rem);
  font-weight: 700;
  margin: 0;
}

.site-tagline {
  font-size: clamp(0.65rem, 0.9vw, 0.75rem);
  color: #555;
  margin-top: 2px;
}

/* Show long by default, hide short */
.long-title, .long-tagline { display: block; }
.short-title, .short-tagline { display: none; }

/* ========================
   Below 400px → Shorter text
======================== */
@media (max-width: 400px) {
  .navbar-brand {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .logo-text {
    margin-left: 0;
    margin-top: 5px;
  }

  /* Hide long version */
  .long-title, .long-tagline { display: none; }

  /* Show short version */
  .short-title, .short-tagline { display: block; }

  .short-title {
    font-size: 0.9rem;
  }

  .short-tagline {
    font-size: 0.7rem;
  }

  .logo-img {
    height: 38px;
    width: 38px;
  }
}

.drawer-navbar .nav-link {
  display: block;
  width: 100%;
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
  background: #fff;
  color: #000;
  font-weight: 500;
}
.drawer-navbar .nav-link:hover {
  background: #f8f9fa;
}
.drawer-navbar .submenu .dropdown-item {
  padding: 10px 25px;
  border-bottom: 1px solid #f1f1f1;
  font-size: 15px;
}
.drawer-navbar .submenu .dropdown-item:last-child {
  border-bottom: none;
}
      `}</style>
    </header>
  );
};

export default Header;
